import { makeActionCreator } from '../../helpers';
import { TableActionTypes } from '../types';

const setPagination = makeActionCreator(TableActionTypes.setPagination, ['pagination']);

const setSortBy = makeActionCreator(TableActionTypes.setSortBy, ['sortBy']);

export default {
  setPagination,
  setSortBy,
};
